import { CSSProperties, useEffect, useRef } from 'react';
import { FormProvider } from 'react-hook-form';
import { useListingRequestFormHook, useListingRequest } from '@vivli/features/listing-request/infrastructure/hook';
import { useListingRequestContext } from '@vivli/features/listing-request/infrastructure/context';
import { ListingRequestHeaderComponent } from './header/listing-request-header.component';
import { ListingRequestRoutesComponent } from './nav/listing-request-routes.component';
import { ListingRequestTabsComponent } from './nav/listing-request-tabs.component';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { NotificationContextWrapper } from '@vivli/shared/features/notification/infrastructure/wrappers';
import { ListingRequestContextWrapper } from '@vivli/features/listing-request/infrastructure/wrappers';

const bodyContainerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 2,
    height: 'calc(100% - 70px)',
    overflow: 'auto'
};

export const ListingRequestFormComponent = () => {
    const { listingRequest, ...props } = useListingRequest();
    const formApi = useListingRequestFormHook(listingRequest);
    // Tracks which listingRequest.id we've already populated the form for, so internal
    // setListingRequest calls (e.g. from handleFundingOrgChange after adding an ROR
    // funder) don't re-fire reset and clear the dirty flag mid-edit. Use `null`
    // sentinel for "never reset yet" so undefined ids on new drafts still trigger
    // the initial population once.
    const lastResetForId = useRef<string | undefined | null>(null);

    useEffect(() => {
        // force initial validation
        formApi.trigger();
    }, []);

    useEffect(() => {
        if (!listingRequest) return;
        if (lastResetForId.current === listingRequest.id) return;
        lastResetForId.current = listingRequest.id;

        formApi.reset(listingRequest);
    }, [listingRequest])

    if (!listingRequest) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <FormProvider {...formApi}>
            <ListingRequestContextWrapper {...props} listingRequest={listingRequest}>
                <ListingRequestHeaderComponent />
                <div style={bodyContainerStyle} className="do-not-print">
                    <ListingRequestTabsComponent />
                    <NotificationContextWrapper>
                        <ListingRequestRoutesComponent />
                    </NotificationContextWrapper>
                </div>
            </ListingRequestContextWrapper>
        </FormProvider>
    );
};
